<template>
	<div class="home">
		<div id="home-content">
			<div class="container" style="padding-top: 150px">
				<div class="row justify-content-center">
					<div class="col-lg-8">
						<h1 class="text-center mb-3 text-gradient">Catat Resolusi Github Anda Tahun Ini. Tingkatkan Statistik Profil</h1>
						<p class="text-center mb-5">Github memiliki statistik yang dapat dijadikan tolak ukur keaktifan seseorang dalam dunia software development, seperti jumlah repository, star, fork dan jumlah kontribusi. Semakin banyak, semakin baik!</p>
						<div v-if="is_login" class="text-center">
							<a class="btn btn-gradient" @click="gotoUserPage">Progress Saya</a>
						</div>
						<div v-else>
							<form v-on:submit.prevent="onSubmit" style="position: relative;">
								<input type="text" class="form-control" v-model="username" placeholder="Masukkan username github" required="" maxlength="16">
								<i v-if="isLoading" class="fa fa-spin fa-spinner" style="position: absolute; top:10px;right: 10px;"></i>
								<small class="text-muted font-courier">Ketik lalu tekan enter</small>
							</form>
						</div>
					</div>
				</div>
			</div>
		</div>
		<b-modal id="modalPassword" title="Password" hide-footer content-class="bg-black">
			<form v-on:submit.prevent="login">
				<p>Halo {{username}}, silahkan masukkan password anda.</p>
				<input type="password" class="form-control" v-model="password" name="password" required="" maxlength="16">
				<p class="text-center mt-3 mb-0">
					<button type="sumbit" class="btn btn-sm btn-primary">
						<span v-if="!isLoadingLogin">OK</span>
						<span v-if="isLoadingLogin"><i class="fa fa-spin fa-spinner"></i></span>
					</button>
				</p>
			</form>
		</b-modal>
		<b-modal id="modalInfoPassword" title="Informasi" hide-header hide-footer content-class="bg-black">
			<form v-on:submit.prevent="loginNewUser">
				<p class="text-center">
					Halo {{username}},<br /> Demi keamanan, kami mengatur password untuk pengguna yang masuk. Password anda saat ini sama dengan username.<br /><br />Terima kasih :)
				</p>
				<p class="text-center mt-3 mb-0">
					<button type="submit" class="btn btn-sm btn-primary">OK</button>
				</p>
			</form>
		</b-modal>
		<div id="home-bg">
			<div
				v-for="(b, i) in bg"
				class="bg-comp"
				:class="'anim-'+b"
				:style="{ backgroundImage: 'url('+require('../assets/img/bg/'+b+'.svg')+')' }"
				:key="i">
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'
import firebase from './../services/firebase'
import './../assets/css/home.css'
export default {
	data () {
		return {
			username: '',
			password: '',
			true_password: '',
			is_login: false,
			bg: [16, 15, 5, 1, 2, 21, 11, 10, 7, 22, 4, 1, 13, 21, 10, 7, 14, 16, 15, 7, 4, 22, 22, 2, 12, 20, 8, 9, 22, 10, 11, 22, 11, 2, 6, 22, 21, 14, 2, 22, 15, 11, 22, 8, 9, 2, 3, 22, 22, 13, 17, 3, 5, 7, 22, 18, 11, 1, 22, 1, 10, 12, 14, 21, 3, 1, 14, 13, 15, 20, 6, 7, 22, 11, 16, 15, 5, 1, 2, 21, 11, 10, 7, 22, 4, 1, 13, 21, 10, 7, 14, 16, 15, 7, 4, 22, 22, 2, 12, 20, 8, 9, 22, 10, 11, 22, 11, 2, 6, 22, 21, 14, 2, 22, 15, 11, 22, 8, 9, 2, 3, 22, 22, 13, 17, 3, 5, 7, 22, 18, 11, 1, 22, 1, 10, 12, 14, 21, 3, 1, 14, 13, 15, 20, 6, 7, 22, 11, 16, 15, 5, 1, 2, 21, 11, 10, 7, 22, 4, 1, 13, 21, 10, 7, 14, 16, 15, 7, 4, 22, 22, 2, 12, 20, 8, 9, 22, 10, 11, 22, 11, 2, 6, 22, 21, 14, 2, 22, 15, 11, 22, 8, 9, 2, 3, 22, 22, 13, 17, 3, 5, 7, 22, 18, 11, 1, 22, 1, 10, 12, 14, 21, 3, 1, 14, 13, 15, 20, 6, 7, 22, 11, 16, 15, 5, 1, 2, 21, 11, 10, 7, 22, 4, 1, 13, 21, 10, 7, 14, 16, 15, 7, 4, 22, 22, 2, 12, 20, 8, 9, 22, 10, 11, 22, 11, 2, 6, 22, 21, 14, 2, 22, 15, 11, 22, 8, 9, 2, 3, 22, 22, 13, 17, 3, 5, 7, 22, 18, 11, 1, 22, 1, 10, 12, 14, 21, 3, 1, 14, 13, 15, 20, 6, 7, 22, 11, 16, 15, 5, 1, 2, 21, 11, 10, 7, 22, 4, 1, 13, 21, 10, 7, 14, 16, 15, 7, 4, 22, 22, 2, 12, 20, 8, 9, 22, 10, 11, 22, 11, 2, 6, 22, 21, 14, 2, 22, 15, 11, 22, 8, 9, 2, 3, 22, 22, 13, 17, 3, 5, 7, 22, 18, 11, 1, 22, 1, 10, 12, 14, 21, 3, 1, 14, 13, 15, 20, 6, 7, 22, 11],
			isLoading: false,
			isLoadingLogin: false
		}
	},
	methods: {
		onSubmit () {
			this.isLoading = true
			if (navigator.onLine) {
				// search dulu ada gak usernya
				axios
					.get('https://api.github.com/users/' + this.username)
					.then(() => {
						// console.log(res)
						this.insertDb()
					})
					.catch(() => {
						alert('Pengguna tidak ditemukan')
					})
			} else {
				setTimeout(() => {
					// testing user baru
					// this.$bvModal.show('modalInfoPassword')

					// testing user jhonarendra
					this.$bvModal.show('modalPassword')
					this.true_password = '88888888'
				}, 2000)
			}
		},
		insertDb () {
			const db = firebase.firestore()
			// cek apa sudah ada username di db
			db.collection('resolution')
				.get()
				.then((q) => {
					let userExist = false
					q.forEach((doc) => {
						if (doc.data().username === this.username) {
							userExist = true
							this.true_password = doc.data().password
						}
					})
					if (!userExist) { // kalau gak ada di db
						// insert baru
						db.collection('resolution')
							.add({
								username: this.username,
								password: this.username,
								resolution: {
									repo: 0,
									commit: 0,
									star: 0,
									fork: 0,
									follower: 0,
									pull_req: 0
								}
							})
							.then(() => {
								this.$bvModal.show('modalInfoPassword')
							})
							.catch((error) => {
								alert(error)
								console.error('Error updating document: ', error)
							})
					} else {
						this.$bvModal.show('modalPassword')
					}
				})
				.catch((error) => {
					alert(error)
					console.error('Error getting documents: ', error)
				})
		},
		login () {
			this.isLoadingLogin = true
			if (this.true_password === this.password) {
				setTimeout(() => {
					localStorage.setItem('gr_username', this.username)
					this.is_login = true
					this.isLoading = false
					this.isLoadingLogin = false
					this.$bvModal.hide('modalPassword')
					document.getElementsByClassName('home')[0].classList.remove('show')
				}, 2000)
				setTimeout(() => {
					this.$router.push({ path: '/resolusi-github/' + this.username })
				}, 2500)
			} else {
				setTimeout(() => {
					alert('Password salah')
					this.isLoading = false
					this.isLoadingLogin = false
					this.username = ''
					this.password = ''
					this.$bvModal.hide('modalPassword')
				}, 2000)
			}
		},
		loginNewUser () {
			localStorage.setItem('gr_username', this.username)
			this.is_login = true
			this.isLoading = false
			this.isLoadingLogin = false
			document.getElementsByClassName('home')[0].classList.remove('show')
			setTimeout(() => {
				this.$router.push({ path: '/resolusi-github/' + this.username })
			}, 500)
		},
		gotoUserPage () {
			document.getElementsByClassName('home')[0].classList.remove('show')
			setTimeout(() => {
				this.$router.push({ path: '/resolusi-github/' + this.username })
			}, 500)
		}
	},
	mounted () {
		setTimeout(() => {
			document.getElementsByClassName('home')[0].classList.add('show')
		}, 500)
		if (localStorage.gr_username) {
			this.username = localStorage.getItem('gr_username')
			this.is_login = true
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped="">

</style>
